import { gql } from '@apollo/client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'src/common/constants';
import images from 'src/common/images';
import { ErrorMstHinmei, MstHinmei, MutationSet } from 'src/common/interfaces';
import { RecordState } from 'src/common/string-enum';
import { ErrorMessage, InfoMessage, InfoWord } from 'src/enum/messsage-enum';
import { deleteMstHinmei, insertMstHinmei, updateMstHinmei } from 'src/graphql/mutations';
import { getMstHinmei } from 'src/graphql/queries';
import { useAppLazyQuery, useAppMutation } from 'src/libs/hooks';
import utility from 'src/libs/utility';
import MainLayout from '../main-layout';

const defaultErrorMstHinmei = {
  isErrorHinCd: false,
  isErrorHinNm: false,
};

const optionsCodeClassifyProduct = [
  { value: 1, label: 'ソフトウェア' },
  { value: 2, label: 'テンプレート' },
  { value: 3, label: 'ライセンス' },
  { value: 4, label: 'ユースウェア' },
  { value: 5, label: 'KDSS保守' },
];
const maintenanceOptions = [
  { value: 1, label: 'ソフトウェア' },
  { value: 2, label: 'テンプレート' },
  { value: 3, label: 'ライセンス' },
];

const optionsDiscount = [
  { value: 0, label: 'x' },
  { value: 1, label: 'o' },
];

const emptyHimmei = {
  mh_available_kb: optionsDiscount[0].value.toString(),
  mh_discount_kb: optionsDiscount[0].value.toString(),
  mh_hin_cd: '',
  mh_hin_kb: optionsCodeClassifyProduct[0].value.toString(),
  mh_hin_nm: '',
  mh_maintenance_tani: 0,
  mh_maintenance_kb: maintenanceOptions[0].value.toString(),
  mh_freename_kb: optionsDiscount[0].value,
  isCannotEditHinCd: false,
  recordState: RecordState.INSERT,
  error: defaultErrorMstHinmei,
  isBeginData: false,
  isSelected: false,
};

const HinmeiManage = () => {
  const { confirmAlert, showAlertMessage, registerData } = utility;
  const header = ['コード', '名称', '区分', '保守単位', '保守区分', '一括割引対象', '名称自由入力', '使用可', '削除'];
  const [mstHinmei, setMstHinmei] = useState<MstHinmei[]>([]);
  const [removedMstHinmei, setRemovedMstHinmei] = useState<MstHinmei[]>([]);
  const [beginLengthListRemarks, setBeginLengthListRemarks] = useState<number>(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuthenticator((context) => [context.user]);
  const [insertFunc] = useAppMutation({ query: gql(insertMstHinmei) });
  const [updateFunc] = useAppMutation({ query: gql(updateMstHinmei) });
  const [deleteFunc] = useAppMutation({ query: gql(deleteMstHinmei) });

  const [searchMstHinmei, { data: mstHinmeiData, loading: isMstHinmeiLoading }] = useAppLazyQuery({
    query: gql(getMstHinmei),
    onCompleted: () => {
      setRemovedMstHinmei([]);
    },
  });

  const renderTableHeader = useMemo(() => {
    return header.map((key, index) => (
      <th
        className="p-[8px] border-[1px] border-solid border-[#fff] pt-[12px] pb-[12px] text-center bg-[#a8d08d] text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  }, []);

  const renderTableData = useMemo(() => {
    if (!mstHinmei || mstHinmei.length <= 0) return;
    return mstHinmei.map((himmei: MstHinmei, index: number) => {
      const isLastItem = index === mstHinmei.length - 1;
      const styleInput = (isError: boolean | undefined) => {
        return `${
          isError ? 'border-[#FF0000] border-[2px] rounded-md' : 'border-{transparent}'
        } pl-[5px] bg-transparent h-[40px] w-full`;
      };

      return (
        <tr className="odd:bg-[#e2efd9]" key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <input
              className={`${styleInput(himmei.error.isErrorHinCd)} text-right`}
              onChange={(event) => {
                if (event.target.value.length === 9) return false;
                handleChangeHinmei(event.target.value, index, 'mh_hin_cd');
              }}
              type="number"
              name="mh_hin_cd"
              value={himmei.mh_hin_cd.toString()}
              disabled={himmei.isCannotEditHinCd}
              min={1}
            />
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <input
              className={styleInput(himmei.error.isErrorHinNm)}
              onChange={(event) => handleChangeHinmei(event.target.value, index, 'mh_hin_nm')}
              type="text"
              name="mh_hin_nm"
              value={himmei.mh_hin_nm}
              maxLength={50}
            />
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <select
              className={styleInput(false)}
              name="mh_hin_kb"
              onChange={(event) => handleChangeHinmei(event.target.value, index, 'mh_hin_kb')}
              value={himmei.mh_hin_kb ?? ''}
            >
              {optionsCodeClassifyProduct.map((itemOption) => {
                return (
                  <option key={`${itemOption.value}`} value={`${itemOption.value}`}>
                    {itemOption.label}
                  </option>
                );
              })}
            </select>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <input
              className={`${styleInput(false)} text-right`}
              onChange={(event) => {
                if (event.target.value.length === 9) return false;
                handleChangeHinmei(event.target.value, index, 'mh_maintenance_tani');
              }}
              type="number"
              name="mh_maintenance_tani"
              value={himmei.mh_maintenance_tani.toString()}
              min={1}
            />
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <select
              className={styleInput(false)}
              name="mh_maintenance_kb"
              onChange={(event) => handleChangeHinmei(event.target.value, index, 'mh_maintenance_kb')}
              value={himmei.mh_maintenance_kb ?? ''}
            >
              {maintenanceOptions.map((itemOption) => {
                return (
                  <option key={`${itemOption.value}`} value={`${itemOption.value}`}>
                    {itemOption.label}
                  </option>
                );
              })}
            </select>
          </td>

          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <select
              className={`${styleInput(false)} text-center`}
              name="mh_discount_kb"
              onChange={(event) => handleChangeHinmei(event.target.value, index, 'mh_discount_kb')}
              value={himmei.mh_discount_kb ?? ''}
            >
              {optionsDiscount.map((itemOption) => {
                return (
                  <option key={`${itemOption.value}`} value={`${itemOption.value}`}>
                    {itemOption.label}
                  </option>
                );
              })}
            </select>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <select
              className={`${styleInput(false)} text-center`}
              name="mh_freename_kb"
              onChange={(event) => handleChangeHinmei(event.target.value, index, 'mh_freename_kb')}
              value={himmei.mh_freename_kb ?? ''}
            >
              {optionsDiscount.map((itemOption) => {
                return (
                  <option key={`${itemOption.value}`} value={`${itemOption.value}`}>
                    {itemOption.label}
                  </option>
                );
              })}
            </select>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff]">
            <select
              className={`${styleInput(false)} text-center`}
              name="mh_available_kb"
              onChange={(event) => handleChangeHinmei(event.target.value, index, 'mh_available_kb')}
              value={himmei.mh_available_kb ?? ''}
            >
              {optionsDiscount.map((itemOption) => {
                return (
                  <option key={`${itemOption.value}`} value={`${itemOption.value}`}>
                    {itemOption.label}
                  </option>
                );
              })}
            </select>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#fff] text-center">
            <button onClick={() => onPressConfirmRemove(index)}>
              {!isLastItem ? <img src={images.icDelete} alt="" className="w-[20px]" /> : null}
            </button>
          </td>
        </tr>
      );
    });
  }, [mstHinmei]);

  const handleChangeHinmei = (value: string | number, index: number, typeHinmei: string) => {
    const newListMstHinmei = [...mstHinmei];
    newListMstHinmei[index] = { ...newListMstHinmei[index], ...{ [typeHinmei]: value } };
    const errorObject: ErrorMstHinmei = { ...newListMstHinmei[index].error };
    switch (typeHinmei) {
      case 'mh_hin_cd':
        errorObject.isErrorHinCd = false;
        break;
      case 'mh_hin_nm':
        errorObject.isErrorHinNm = false;
        break;
    }
    newListMstHinmei[index].error = { ...newListMstHinmei[index].error, ...errorObject };
    if (newListMstHinmei[index].isBeginData) {
      newListMstHinmei[index].recordState = RecordState.UPDATE;
    }
    setMstHinmei(newListMstHinmei);
  };

  const prepareDataApplyApi = (officeData: MstHinmei) => {
    return {
      mh_available_kb: officeData.mh_available_kb,
      mh_discount_kb: officeData.mh_discount_kb,
      mh_hin_cd: officeData.mh_hin_cd,
      mh_hin_kb: officeData.mh_hin_kb,
      mh_hin_nm: officeData.mh_hin_nm,
      mh_maintenance_kb: Number(officeData.mh_maintenance_kb),
      mh_freename_kb: Number(officeData.mh_freename_kb),
      mh_maintenance_tani: officeData.mh_maintenance_tani,
    };
  };

  const isEmptyData = (data: MstHinmei) => {
    return data.mh_hin_cd === '' && data.mh_hin_nm === '' && data.mh_maintenance_tani === 0;
  };

  const isExistItem = () => {
    const newListHinmei = [...mstHinmei];
    const valueArr = newListHinmei.map(function (item) {
      return item.mh_hin_cd.toString();
    });
    const isDuplicate = valueArr.some(function (item, idx) {
      if (valueArr.indexOf(item) !== idx) {
        newListHinmei[idx].error.isErrorHinCd = true;
        return true;
      }
      return false;
    });
    setMstHinmei(newListHinmei);
    return isDuplicate;
  };

  const checkError = (itemHinmei: MstHinmei) => {
    const isErrorHinCd = itemHinmei.mh_hin_cd.length < 2;
    const isErrorHinNm = itemHinmei.mh_hin_nm === '';

    return { isErrorHinCd, isErrorHinNm };
  };

  const validates = () => {
    const newListHinmei = [...mstHinmei];
    newListHinmei.pop();
    const newListAddError = newListHinmei.map((itemHinmei: MstHinmei) => {
      return { ...itemHinmei, error: checkError(itemHinmei) };
    });
    setMstHinmei(newListAddError);
    const indexItemError = newListHinmei.findIndex(
      (itemHinmei: MstHinmei) => itemHinmei.mh_hin_cd.length < 2 || itemHinmei.mh_hin_nm === ''
    );
    if (indexItemError !== -1) {
      showAlertMessage('', ErrorMessage.INPUT_ERROR, InfoWord.ERROR, InfoWord.OK);
      return false;
    }
    if (isExistItem()) {
      showAlertMessage('', InfoMessage.REGISTR_DUPLICATION, InfoWord.ERROR, InfoWord.OK);
      return false;
    }
    return true;
  };

  const executeRegister = async () => {
    const mstHinmeiNewList = [...mstHinmei];
    const insertData = mstHinmeiNewList.filter((item: MstHinmei) => item.recordState === RecordState.INSERT);
    const updateData = mstHinmeiNewList.filter((item: MstHinmei) => item.recordState === RecordState.UPDATE);

    // 最終行(新規行)を除外
    insertData.pop();

    const delSet: MutationSet<MstHinmei> = {
      recordState: RecordState.DELETE,
      data: removedMstHinmei,
      func: (data: MstHinmei) => deleteFunc({ variables: { input: { mh_hin_cd: data.mh_hin_cd } } }),
    };
    const updSet: MutationSet<MstHinmei> = {
      recordState: RecordState.UPDATE,
      data: updateData,
      func: (data: MstHinmei) => updateFunc({ variables: { input: prepareDataApplyApi(data) } }),
    };
    const insSet: MutationSet<MstHinmei> = {
      recordState: RecordState.INSERT,
      data: insertData,
      func: (data: MstHinmei) => insertFunc({ variables: { input: prepareDataApplyApi(data) } }),
    };

    const searchFunc = () => searchMstHinmei({ variables: { input: {} } });

    registerData<MstHinmei>({
      mutationSets1: [delSet, updSet, insSet],
      validates,
      searchFunc,
    });
  };

  const onPressConfirmRegister = () => {
    Auth.currentAuthenticatedUser()
      .then(() =>
        confirmAlert(InfoMessage.CONFIRM_REGISTR, '', InfoWord.WARNING, InfoWord.YES, InfoWord.NO, executeRegister)
      )
      .catch(() => {
        signOut();
        navigate(LOGIN_PATH, { replace: true, state: { from: location } });
      });
  };

  const onPressRemove = (index: number) => {
    const newListMstHinmei = [...mstHinmei];
    if (index < beginLengthListRemarks) {
      const newListRemove = [...removedMstHinmei];
      const dataItem = mstHinmei[index];
      setBeginLengthListRemarks(beginLengthListRemarks - 1);
      newListRemove.push({ ...dataItem, recordState: RecordState.DELETE });
      setRemovedMstHinmei(newListRemove);
    }
    newListMstHinmei.splice(index, 1);
    setMstHinmei(newListMstHinmei);
  };

  const onPressConfirmRemove = (index: number) => {
    confirmAlert(InfoMessage.CONFIRM_REMOVE, '', InfoWord.WARNING, InfoWord.YES, InfoWord.NO, () =>
      onPressRemove(index)
    );
  };

  useEffect(() => {
    if (mstHinmei?.length < 1) return;
    const lastIndex = mstHinmei.length - 1;
    const newListMstHinmei = [...mstHinmei];

    if (!isEmptyData(newListMstHinmei[lastIndex])) {
      newListMstHinmei.push(emptyHimmei);
      setMstHinmei(newListMstHinmei);
    }
  }, [mstHinmei]);

  useEffect(() => {
    if (!mstHinmeiData) return;
    const newListHinmei = mstHinmeiData.getMstHinmei.map((item: MstHinmei) => {
      return {
        ...item,
        recordState: RecordState.NONE,
        isCannotEditHinCd: true,
        error: defaultErrorMstHinmei,
        isBeginData: true,
      };
    });
    setBeginLengthListRemarks(mstHinmeiData.getMstHinmei.length);
    newListHinmei.sort((a: MstHinmei, b: MstHinmei) => Number(a.mh_hin_cd) - Number(b.mh_hin_cd));
    newListHinmei.push(emptyHimmei);
    setMstHinmei(newListHinmei);
  }, [mstHinmeiData]);

  useEffect(() => {
    searchMstHinmei({ variables: { input: {} } });
  }, []);

  return (
    <MainLayout>
      <div className="flex flex-col items-center">
        <p className="p-[20px]">品名管理</p>
        <div className="flex w-4/5">
          <button
            onClick={onPressConfirmRegister}
            className="border-[#000000] border-[1px] p-[10px] mt-[25px] mb-[25px] text-center h-[50px] w-[100px] font-bold"
          >
            登録
          </button>
        </div>
        <table className="border-collapse border-[3px] border-solid border-[#ddd] w-4/5 td:p-[10px]">
          <thead>
            <tr className="hover:opacity-80 even:bg-[#e2efd9] ">{renderTableHeader}</tr>
          </thead>
          <tbody>
            {isMstHinmeiLoading ? (
              <tr className="hover:opacity-80 even:bg-[#e2efd9]">
                <td
                  colSpan={header.length}
                  className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                >
                  Loading...
                </td>
              </tr>
            ) : (
              renderTableData
            )}
          </tbody>
        </table>
      </div>
    </MainLayout>
  );
};

export default HinmeiManage;
